import React,{useState} from "react";
import { Block, BlockContent, BlockDes, BlockHead, BlockTitle, Button, PreviewCard } from "../../components/Component";
import Logo from "../../images/logo12.png";
import LogoDark from "../../images/logo12.png";
import { FormGroup } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link,useHistory } from "react-router-dom";
import { authService } from "../../_services/auth";
import {toaster} from "../../_helpers/toaster";

const ResetPassword = () => {

  const [data,setData] = useState({email:"",password:"",cpassword:"",code:""});
  const history = useHistory();

  const onInputChange=(e) =>{
    const {name,value} = e.target;
    setData(pv=>({...pv,[name]:value}));

}

  const handleSubmit = (e) =>{
    e.preventDefault();

    if(!data.password || !data.cpassword || !data.email || !data.code) return toaster.error('All fields are required.')
    if(data.password !== data.cpassword) return toaster.error('Password must be same')
        
    
    authService.update(data).then(
      result =>{
        // console.log(result);
        toaster.success(result.msg);
        history.push("/auth-login")
      },
      err =>{
        console.log(err);
        toaster.error(err);
      }
    )
}

  return (
    <React.Fragment>
      <Head title="Forgot-Password" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={"/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h5">Update password</BlockTitle>                
              </BlockContent>
            </BlockHead>
            <form>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="email"> Email </label>
                </div>
                <input
                  type="text" placeholder="Enter your email"
                  className="form-control form-control-lg"
                  id="email" name="email" value={data.email} onChange={onInputChange}                  
                />
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password"> Password </label>
                </div>
                <input
                  type="password" placeholder="Enter your password"
                  className="form-control form-control-lg"
                  id="password" name="password" value={data.password} onChange={onInputChange}                  
                />
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="cpassword"> Confirm Password </label>
                </div>
                <input
                  type="password" placeholder="Enter confirm password"
                  className="form-control form-control-lg"
                  id="cpassword" name="cpassword" value={data.cpassword} onChange={onInputChange}                  
                />
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="code"> Access Code </label>
                </div>
                <input
                  type="text" placeholder="Enter access code"
                  className="form-control form-control-lg"
                  id="code" name="code" value={data.code} onChange={onInputChange}                  
                />
              </FormGroup>

              <FormGroup>
                <Button color="primary" size="lg" className="btn-block" onClick={handleSubmit}>
                  Update Password
                </Button>
              </FormGroup>
            </form>
            <div className="form-note-s2 text-center pt-4">
              <Link to={`/auth-login`}>
                <strong>Return to login</strong>
              </Link>
            </div>
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default ResetPassword;
